<template>
  <div id="landing">
    <div class="background">
      <div class="html-embed html-embed-2 w-embed">
        <div class="marquee">
          <div>
            <span>Make A Move</span>
            <span>Make A Move</span>
          </div>
        </div>
      </div>
      <div class="bg" />
      <div
        data-autoplay="true"
        data-loop="true"
        data-wf-ignore="true"
        class="bg-vid w-background-video w-background-video-atom"
      >
        <video
          autoplay=""
          loop=""
          style="background-image:url(&quot;mam-trim-poster-00001.jpg&quot;)"
          muted=""
          playsinline=""
          data-wf-ignore="true"
        >
          <source src="@/assets/videos/mam-trim-poster-00001.jpg">
          <source src="@/assets/videos/mam-trim-transcode.webm">
          <source src="@/assets/videos/mam-trim-transcode.mp4">
        </video>
      </div>
    </div>
    <div class="foreground">
      <div class="top">
        <div
          class="header"
          data-ix="new-interaction"
        >
          <div class="div-block-16">
            <img
              src="@/assets/images/Make-A-Move-LOGO.png"
              class="logo-image logo"
            >
          </div>
        </div>
        <div class="content-wrapper w-row">
          <div class="device-coloumn w-col w-col-5 w-col-stack">
            <div class="hero-device-wrapper w-clearfix">
              <div class="device">
                <div class="screen-wrapper">
                  <div class="screen-mask screen-home-content">
                    <div
                      data-w-id="5417da21-30f0-4b59-a953-9bcc3cf1db0d"
                      class="screen-home-content"
                    >
                      <img
                        src="@/assets/images/head.png"
                        class="app-header"
                      >
                      <img
                        src="@/assets/images/card1.png"
                        class="app-home-card"
                      >
                      <img
                        src="@/assets/images/search.png"
                        class="app-footer"
                      >
                      <img
                        src="@/assets/images/home-card1.png"
                        class="app-home1"
                      >
                      <img
                        src="@/assets/images/test.png"
                        class="app-home2"
                      >
                      <img
                        src="@/assets/images/card-4.png"
                        class="app-home3"
                      >
                      <img
                        src="@/assets/images/card3.png"
                        class="app-home4"
                      >
                      <img
                        src="@/assets/images/home-card.png"
                        class="app-homebase-duplicate"
                      >
                    </div>
                  </div>

                  <img
                    src="@/assets/images/bg.png"
                    class="app-background"
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="content-coloumn w-col w-col-7 w-col-stack">
            <div class="content-text">
              <h1 class="heading">
                Finn noe mer enn bare annonser
              </h1>
              <p class="paragraph">
                Make a Move samler nå Norges boliger i en app slik at du kan delta i boligmarkedet
                på dine egne premisser.<br>‍<br>Registrer deg nå og vær først i køen når vi lanserer
                Norges første bolignettverk.
              </p>
              <div class="form-block w-form">
                <form
                  id="email-form"
                  name="email-form"
                  data-name="Email Form"
                  method="post"
                  action="https://makeamove.us20.list-manage.com/subscribe/post?u=52c4a5735e929299b03f62ff9&amp;amp;id=f0ebfd34a1"
                  class="form"
                >
                  <input
                    id="EMAIL-2"
                    type="email"
                    class="text-field w-input"
                    maxlength="256"
                    name="EMAIL"
                    data-name="EMAIL"
                    placeholder="Epost adresse"
                    required=""
                  >
                  <input
                    type="submit"
                    value="Send inn"
                    data-wait="Please wait..."
                    class="submit-button w-button"
                  >
                </form>
                <div class="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div class="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div
          id="w-node-9bcc3cf1db24-19787bf1"
          class="columns w-row"
        >
          <div class="copyright w-col w-col-5 w-col-small-small-stack w-col-stack">
            <div class="text-block">
              2019 © <br>Make a Move
            </div>
          </div>
          <div class="appstore w-col w-col-4 w-col-small-small-stack w-col-stack">
            <div class="text-block-3">
              <span class="text-span">
                Launching soon...
              </span>
            </div>
            <div class="div_store">
              <div
                id="w-node-9bcc3cf1db2b-19787bf1"
                class="div-block-10"
              >
                <a
                  href="#test"
                  class="link-block w-inline-block"
                >
                  <img
                    src="@/assets/images/App-Store-Icon.png"
                    alt=""
                    class="image-3"
                  >
                </a>
              </div>
              <div
                id="w-node-9bcc3cf1db2e-19787bf1"
                class="div-block-20"
              >
                <a
                  href="#test"
                  class="link-block w-inline-block"
                >
                  <img
                    src="@/assets/images/GooglePlay-Icon.png"
                    alt=""
                    class="image-3"
                  >
                </a>
              </div>
            </div>
          </div>
          <div class="social-media w-col w-col-3 w-col-small-small-stack w-col-stack">
            <div class="div-block-9">
              <a
                href="https://www.instagram.com/makeamove_official/"
                target="_blank"
                class="link-block-2 w-inline-block"
              >
                <img
                  src="@/assets/images/instagram.png"
                  width="25"
                  alt=""
                  class="image-social"
                >
              </a>
            </div>
            <div class="div-block-9">
              <a
                href="https://www.linkedin.com/company/makeamove-com/"
                target="_blank"
                class="link-block-2 w-inline-block"
              >
                <img
                  src="@/assets/images/linkedin.png"
                  width="25"
                  alt=""
                  class="image-social"
                  style="padding: 0 3px;"
                >
              </a>
            </div>
            <div class="div-block-9">
              <a
                href="https://twitter.com/MakeamoveCom"
                target="_blank"
                class="link-block-2 w-inline-block"
              >
                <img
                  src="@/assets/images/twitter.png"
                  width="25"
                  alt=""
                  class="image-social"
                >
              </a>
            </div>
            <div class="div-block-9">
              <a
                href="https://www.facebook.com/Make-a-Move-374114910053666/"
                target="_blank"
                class="link-block-2 w-inline-block"
              >
                <img
                  src="@/assets/images/facebook.png"
                  width="25"
                  alt=""
                  class="image-social"
                  style="padding-bottom: 2px;"
                >
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.body.style.backgroundColor = '#24213d';
  },
};
</script>

<style lang="scss">
@import '../assets/css/normalize.css';
@import '../assets/css/webflow.css';
@import '../assets/css/makeamove.webflow.css';

#landing {
  // hacks
  #email-form {
    width: 100% !important;
  }

  .submit-button {
    margin-left: 0 !important;
  }

  // animation
  @keyframes shrink {
    0%, 80% {
      transform: scale(1);
    }

    95%, 97.6% {
      transform: scale(0.95);
    }

    97.7%, 100% {
      transform: scale(1);
    }
  }

  @keyframes slide {
    0%, 17.4% {
      transform: translateY(0) scale(1);
    }

    19.9%, 36% {
      transform: translateY(-118%) scale(1);
    }

    39.8% {
      opacity: 1;
      transform: translateY(-118%) scale(0.95);
    }

    40%, 100% {
      opacity: 0;
      transform: translateY(-118%) scale(0);
    }
  }

  @keyframes slidelast {
    0%, 17.8% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }

    19.9% {
      opacity: 1;
      transform: translateY(-118%) scale(1);
    }

    20%, 100% {
      opacity: 0;
      transform: translateY(-118%) scale(1);
    }
  }

  .app-home-card {
    animation: shrink 4s ease-out infinite;
  }

  .app-home1 {
    animation: slide 20s ease-out infinite;
  }

  .app-home2 {
    animation: slide 20s ease-out 4s infinite;
  }

  .app-home3 {
    animation: slide 20s ease-out 8s infinite;
  }

  .app-home4 {
    animation: slide 20s ease-out 12s infinite;
  }

  .app-homebase-duplicate {
    animation: slidelast 20s ease-out 16s infinite;
  }

  // the rest
  .marquee {
    width: 100%;
    height:20vh;
    overflow: hidden;
    position: relative;
  }

  .marquee div {
    display: block;
    width: 270%;
    position: absolute;
    overflow: hidden;
    animation: marquee 10s linear infinite;
  }

  .marquee span {
    float: left;
    width: 50%;
  }

  @keyframes marquee {
    0% { left: 0; }
    100% { left: -100%; }
  }

  @media screen and (max-width:1240px) and (min-width:960px) and (orientation:portrait) {
    .device-coloumn {
      display:none;
    }

    .content-coloumn {
      width:100%;
      padding-right:50px;
    }

    .heading {
      font-size: 6em;
    }

    .div_store {
      margin-left:-25vw;
    }
  }

  @media screen and (max-width:960px) and (min-width:680px) and (orientation:portrait) {
    .div_store {
      margin-left: -15vw;
      margin-right: -15vw;
    }
  }

  @media screen and (max-width: 991px) and (orientation:landscape) {
    .heading {
      font-size: 7vh;
    }

    .paragraph {
      font-size: 3vh;
    }
  }

  @media screen and (min-width: 991px) and (max-width: 1240px) and (orientation:landscape) {
    .heading {
      font-size: 6vh;
    }

    .paragraph {
      font-size: 2vh;
    }

    .div_store {
      margin-right: -15vw;
    }
  }

  @media screen and (max-width: 991px) and (orientation:landscape) {
    .w-input {
      height: 30px;
    }

    .submit-button {
      line-height: 12px;
    }
  }
}
</style>
